import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { clearSimulatedNow } from 'simulated-clock';

// รูปแบบของ <input type="datetime-local"> = เวลาไทย ไม่มี timezone — ?now= ที่ไม่มี zone ถือเป็น +07:00 อยู่แล้ว
const INPUT_FORMAT = 'YYYY-MM-DDTHH:mm';
// พิมพ์ทีละช่อง (วัน/เดือน/ปี/ชม.) input ส่งค่าทุกครั้ง — รอให้หยุดพิมพ์ก่อนค่อยโหลดใหม่ กันเด้งกลางคัน
const APPLY_DELAY_MS = 800;

// แถบเตือนบน staging ขณะใช้เวลาจำลอง (?now=) — กันลืมว่ากำลังทดสอบด้วยเวลาไม่จริง
// เปลี่ยนวันเวลาในช่องแล้วมีผลทันที (6 ต.ค. 69): ใส่กลับเป็น ?now= แล้วโหลดหน้าใหม่ (initSimulatedClock จำค่าเหมือนพิมพ์ใน URL)
const SimulatedClockBanner = ({ simulatedNow }) => {
  const current = simulatedNow ? moment(simulatedNow).utcOffset(7 * 60).format(INPUT_FORMAT) : '';
  const [picked, setPicked] = useState(current);
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);
  if (!simulatedNow) return null;

  const reloadWith = (now) => {
    clearTimeout(timer.current);
    const url = new URL(window.location.href);
    if (now) url.searchParams.set('now', now);
    else url.searchParams.delete('now');
    window.location.replace(url.toString());
  };
  // ค่าว่าง = ยังกรอกไม่ครบ/ไม่ถูก (browser คืน '') · ค่าเดิม = ไม่ต้องโหลดใหม่
  const apply = (value) => {
    clearTimeout(timer.current);
    if (value && value !== current) reloadWith(value);
  };
  const onChange = (event) => {
    const { value } = event.target;
    setPicked(value);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => apply(value), APPLY_DELAY_MS);
  };
  const onClear = () => {
    clearSimulatedNow();
    reloadWith(null);
  };

  // <aside> ไม่ใช่ <div> — global CSS `#root > div { min-height: 100vh }` จะยืดแถบเต็มจอ
  return (
    <aside
      role="status"
      aria-label="เวลาจำลอง (staging) — ระบบใช้เวลานี้แทนเวลาจริง"
      style={{ position: 'sticky', top: 0, zIndex: 1000, background: '#fde68a', color: '#78350f', padding: '6px 16px', fontSize: 14, display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', gap: 8 }}
    >
      <span>เวลาจำลอง (staging):</span>
      <input
        type="datetime-local"
        aria-label="เลือกวันเวลาจำลอง"
        value={picked}
        onChange={onChange}
        onBlur={() => apply(picked)}
        onKeyDown={(event) => { if (event.key === 'Enter') apply(picked); }}
        style={{ font: 'inherit', color: 'inherit', background: '#fffbeb', border: '1px solid #d97706', borderRadius: 4, padding: '1px 4px' }}
      />
      <span aria-hidden="true">·</span>
      <button type="button" onClick={onClear} style={{ textDecoration: 'underline', background: 'none', border: 0, color: 'inherit', cursor: 'pointer', padding: 0, font: 'inherit' }}>
        กลับเวลาจริง
      </button>
    </aside>
  );
};

export default SimulatedClockBanner;
